export function encode(str) {
  return encodeURIComponent(str)
    .replace(/&/g, '%26')
    .replace(/!/g, '%21');
}

export function decode(str) {
  return decodeURIComponent(str)
    .replace(/%26/g, '&')
    .replace(/%21/g, '!');
}